export default __webpack_public_path__ + "static/media/photo--sm--3.c832d999.jpg";